import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrush = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m8.25 9.25 6.982-6.982a1.768 1.768 0 0 1 3.018 1.25v.039c0 .446-.165.877-.464 1.208L11.25 12.25s0-1-1-2-2-1-2-1Zm1 5.5c0 1.657-1.119 2.706-2 3-.881.294-1.5.5-3 .5s-2.5-.5-2.5-.5 1.5-1 1.5-2v-1a3 3 0 0 1 3-3c1.75 0 3 1.25 3 3Z"
	})]
});
const ForwardRef = forwardRef(SvgBrush);
export { ForwardRef as ReactComponent };
